import { render, staticRenderFns } from "./AreaPOA.vue?vue&type=template&id=07239130"
import script from "./AreaPOA.vue?vue&type=script&lang=js"
export * from "./AreaPOA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports